<template>
  <nobr>
    <!-- Botón Personalizado Adicional (Slot) -->
    <slot name="extra" :item="item"></slot>

    <!-- Botón Ver -->
    <button
      v-if="showView"
      class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
      data-toggle="tooltip"
      data-placement="top"
      title="Ver Detalle"
      @click="$emit('view', item)"
    >
      <small class="bi-eye"></small>
    </button>

    <!-- Botón Editar -->
    <button
      v-if="showEdit"
      class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
      data-toggle="tooltip"
      data-placement="top"
      title="Editar"
      @click="$emit('edit', item)"
    >
      <small class="bi-pencil-fill"></small>
    </button>

    <!-- Botón Suspender / Reactivar (Toggle Activo) -->
    <button
      v-if="showToggle"
      :class="isActive ? 'btn btn-warning btn-sm pt-0 pb-1 mr-1' : 'btn btn-success btn-sm pt-0 pb-1 mr-1'"
      data-toggle="tooltip"
      data-placement="top"
      :title="isActive ? 'Suspender' : 'Reactivar'"
      @click="$emit('toggle', item)"
    >
      <small :class="isActive ? 'bi-pause' : 'bi-play'"></small>
    </button>

    <!-- Botón Eliminar -->
    <button
      v-if="showDelete"
      class="btn btn-danger btn-sm pt-0 pb-1"
      data-toggle="tooltip"
      data-placement="top"
      title="Eliminar"
      @click="$emit('delete', item)"
    >
      <small class="bi-trash"></small>
    </button>
  </nobr>
</template>

<script>
export default {
  name: "TableActions",
  props: {
    item: {
      type: Object,
      required: true
    },
    activeKey: {
      type: String,
      default: "activo"
    },
    showView: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showToggle: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive() {
      const val = this.item ? this.item[this.activeKey] : 0;
      return val == 1 || val === "1" || val === true;
    }
  }
};
</script>
